<script>
	import PageSection from "../../components/PageSection.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	import { pageNumber, model } from "../../stores";
	import { projectSettings } from "../../config";
	import { registerFormStart } from "../../tealium";

	export let pageIndex = null;
	export let pageTitle = null;
	export let nextPage = null;
	export let lastVisitedPage = null;
	export let persistUrl = null;
	export let title = null;

	pageNumber.update((p) => pageIndex);
	$model.LastPageVisited = lastVisitedPage;
	document.title = pageTitle;

	//  Get the user Agent
	$model.UserAgent = navigator.userAgent;
	$model.referrer = document.referrer;
	$model.RegistrationSegmentId = null;
</script>

<PageSection>
	<div class="row justify-content-center">
		<div class="col-md-8 col-sm-12">
			<h1 class="text-center">{projectSettings.classActionName}</h1>
			<h2 class="text-center">REGISTRATION FORM</h2>
		</div>
	</div>

	<div class="row justify-content-md-center">
		<div class="col-md-8 col-sm-12">
			<p>
				<strong>
					Registrations for this class action have now closed according to orders of the Court, which required registration by 4:00pm AEDT on 28 February 2025.
				</strong>
			</p>
			<p>
				If you wish to provide a late registration, please email us at <ClassActionEmailAddress/> with an explanation as to why your registration is late. 
				We will consider that information and respond as to potential action that can be taken.
			</p>

			<p>
				If you are in any doubt about whether you have suffered damages, please contact Shine Lawyers on <ClassActionPhoneNumber/> or via email to <ClassActionEmailAddress/>.
			</p>
		</div>
	</div>
</PageSection>

<style>
	h1 {
		margin-bottom: 20px;
	}

	h2 {
		font-size: 1.1em;
		margin-bottom: 16px;
		font-weight: 700;
	}

	a {
		text-decoration: none;
	}

	a:hover {
		text-decoration: underline;
	}

	.register-btn {
		margin-bottom: 20px;
	}
</style>
